import { createContext, useContext } from 'react';
/**
 * @internal Intended for internal use - use it on your own risk
 */
export const BlockNumberContext = createContext(undefined);
/**
 * @public
 */
export function useBlockNumber() {
    return useContext(BlockNumberContext);
}
//# sourceMappingURL=context.js.map